import { fetchViatorProducts } from "lib/api/viator/products/index";
import {
  areCoordinatesInsideBoundingBox,
  calculateExpandedBoundingBox,
  findLatLonDifference,
  findLatLonDifferenceBoundingBox,
} from "utils/helpers/location";

export default async function fetchViatorProductsHandler(req, res) {
  if (req.method !== "GET") {
    return res
      .status(405)
      .json({ statusCode: 405, message: "Method Not Allowed" });
  }

  try {
    const { ids } = req.query;
    const data = await fetchViatorProducts({ ids });

    res.status(200).json(data);
  } catch (error) {
    res.status(500).json({ statusCode: 500, message: error.message });
  }
}

export function filterViatorProductsByDistanceFromCoordinates({
  products,
  coordinates,
}) {
  const productsInProximityToLocation = products?.filter((product) => {
    /* Check lat and lon, and if Mapbox's geocoding of the activity is not close
     ** to the location of the travel guide, then don't include it.
     */
    if (!product?.destinations[0]?.geocodeInfo) {
      return false;
    }

    const relevance = product?.destinations[0]?.geocodeInfo?.relevance;
    if (relevance < 0.2) {
      console.log("Relevance not high enough: ", relevance);
      return true;
    }

    const viatorProductCoordinates = {
      lat: product?.destinations[0]?.geocodeInfo[0]?.center[1],
      lon: product?.destinations[0]?.geocodeInfo[0]?.center[0],
    };

    const { averageDiff } = findLatLonDifference({
      coordinates1: viatorProductCoordinates,
      coordinates2: coordinates,
    });

    if (averageDiff < 2) {
      return true;
    }

    return false;
  });

  return productsInProximityToLocation;
}

export function filterViatorProductsByDistanceFromBoundingBox({
  products,
  boundingBox,
  tolerance,
}) {
  const productsInProximityToLocation = products?.filter((product) => {
    /* Check lat and lon, and if Mapbox's geocoding of the activity is not close
     ** to the location of the travel guide, then don't include it.
     */
    if (!product?.destinations[0]?.geocodeInfo) {
      return false;
    }

    const relevance = product?.destinations[0]?.geocodeInfo?.relevance;
    if (relevance < 0.2) {
      console.log("Relevance not high enough: ", relevance);
      return true;
    }

    const viatorLat = product?.destinations[0]?.geocodeInfo[0]?.center[1];
    const viatorLon = product?.destinations[0]?.geocodeInfo[0]?.center[0];

    const viatorProductCoordinates = {
      lat: viatorLat,
      lon: viatorLon,
    };

    const expandedBoundingBox = calculateExpandedBoundingBox({
      boundingBox,
      expandingFactor: 2,
    });

    const coordinatesAreInsideBoundingBox = areCoordinatesInsideBoundingBox({
      coordinates: viatorProductCoordinates,
      boundingBox: expandedBoundingBox,
    });

    if (coordinatesAreInsideBoundingBox) {
      return true;
    }

    return false;
  });

  return productsInProximityToLocation;
}
